import {Col, Form, Row} from "react-bootstrap";
import {ModalDialog} from "../modal/ModalDialog.js";
import React from "react";
import {APIClient} from "../../core/utils/APIClient.js";
import useForm from "../../core/hooks/useForm.js";
import {fetchPromises} from "../../core/utils/fetchPromises.js";
import crypto from "crypto";

function UserModal({setModal, user, refreshUsers}) {
    const {form, onInputChange} = useForm({
        ...user,
        password: undefined,
        passwordRequired: !user,
    });

    const onModalSaveClick = async () => {
        try {
            let password;
            if (form.password) {
                const shaSum = crypto.createHash('sha1');
                shaSum.update(form.password);
                password = shaSum.digest('hex');
            }

            await APIClient().saveUser({
                ...form,
                password
            });
            refreshUsers();
        } catch (e) {
            console.log(e);
        }
    }

    const onModalClose = () => {
        setModal({
            show: false
        });
    }

    return (
        <ModalDialog show onClose={onModalClose} onCallback={onModalSaveClick} title="User">
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4">
                    Name
                </Form.Label>
                <Col sm="8">
                    <Form.Control type="text" name="name" onChange={onInputChange} value={form.name || ''} required />
                    <Form.Control.Feedback type="invalid">
                        Field is required.
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4">
                    Username
                </Form.Label>
                <Col sm="8">
                    <Form.Control type="text" name="username" onChange={onInputChange} value={form.username || ''} required />
                    <Form.Control.Feedback type="invalid">
                        Field is required.
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4">
                    Password
                </Form.Label>
                <Col sm="8">
                    <Form.Control type="password" name="password" onChange={onInputChange} required={form.passwordRequired}/>
                    {form.passwordRequired &&
                        <Form.Control.Feedback type="invalid">
                            Field is required.
                        </Form.Control.Feedback>
                    }
                </Col>
            </Form.Group>
        </ModalDialog>
    );
}

export default fetchPromises({
    user: (props) => props.userId && ({ name: 'getUser', props: ['userId'] })
}, false)(UserModal);
